export const SearchParamsKeys = {
  QUIZ_ID: "quiz_id",
  SOURCE: "source",
  GB_ID: "gb_id",
} as const;
